import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from 'reactstrap';
import styled from 'styled-components';
import { ListingDTO } from '../../../api/model';
import { actionSetTileLayerOpacity } from '../../../store/Map/TileLayer/actions';
import { selectTileLayersOpacity } from '../../../store/Map/TileLayer/selectors';

interface ActiveMapOpacitySliderProps {
    tileLayer: ListingDTO;
}

const ActiveMapOpacitySlider = (props: ActiveMapOpacitySliderProps) => {
    const tileLayersOpacity = useSelector(selectTileLayersOpacity);

    const dispatch = useDispatch();
    const setTileLayerOpacity = (tileLayerId: number, opacity: number): void => {
        dispatch(actionSetTileLayerOpacity(tileLayerId, opacity));
    };

    const [opacity, setOpacity] = useState(tileLayersOpacity[props.tileLayer.id] || 1.0);
    return (
        <SliderContainer className="opacity-slider">
            <SliderText>Transparency:</SliderText>
            <SliderValue>{(opacity * 100).toFixed()}%</SliderValue>

            <SliderInputContainer>
                <Slider
                    type="range"
                    value={opacity * 100}
                    step={0.01}
                    onChange={(e) => {
                        if (document.activeElement === document.getElementById('listing-comment-input')) {
                            document.getElementById('listing-comment-input')?.blur();
                        }

                        const opacity = parseInt(e.target.value) / 100;
                        setOpacity(opacity);
                        setTileLayerOpacity(props.tileLayer.id, opacity || 0.0001);
                    }}
                />
            </SliderInputContainer>
        </SliderContainer>
    );
};

export default ActiveMapOpacitySlider;

const SliderContainer = styled.div`
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
    width: 100%;
    padding: 12px 4px;
    display: flex;

    @media only screen and (max-width: 600px) {
        border-top: 1px solid rgba(255, 255, 255, 0.3);
        padding: 14px 10px;
    }
`;

const SliderText = styled.p`
    vertical-align: center;
    color: white;
    font-size: 16px;
    margin: 0;
    padding: 0;
`;

const SliderValue = styled.p`
    vertical-align: center;
    color: rgba(255, 255, 255, 0.5);
    font-size: 16px;
    margin: 0px 5px;
    padding: 0;
`;

const SliderInputContainer = styled.div`
    width: 100%;
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Slider = styled<any>(Input)`
    width: 100%;
    background: linear-gradient(
        to left,
        rgba(255, 255, 255, 0.3) ${(props) => 100 - props.value}%,
        #eed926 ${(props) => 100 - props.value}%
    );
    height: 2px;
    padding: 0;
    box-shadow: none !important;
    border: none !important;
    -webkit-appearance: none;
    outline: none;
    border-radius: 5px;
    margin-top: 12px;

    &::-moz-range-thumb {
        appearance: none;
        -webkit-appearance: none;
        background: #eed926;
        height: 12px;
        width: 12px;
        border-radius: 50%;
        cursor: pointer;
    }

    &::-webkit-slider-thumb {
        appearance: none;
        -webkit-appearance: none;
        background: #eed926;
        height: 12px;
        width: 12px;
        border-radius: 50%;
        cursor: pointer;
    }

    &:hover::-moz-range-thumb {
        appearance: none;
        -webkit-appearance: none;
        background: #eed926;
        border-radius: 50%;
        cursor: pointer;
    }

    &:hover::-webkit-slider-thumb {
        appearance: none;
        -webkit-appearance: none;
        background: #eed926;
        border-radius: 50%;
        cursor: pointer;
    }

    &:focus {
        background: linear-gradient(
            to left,
            rgba(255, 255, 255, 0.3) ${(props) => 100 - props.value}%,
            #eed926 ${(props) => 100 - props.value}%
        );
    }
`;
